import {
    Box,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Slider,
} from '@mui/material'
import { maxGeoFenceRadius, minGeoFenceRadius } from '../../constants/constants'
import { ReactElement, useCallback } from 'react'

interface RangeInputProps {
    id: string
    label: string
    value: number
    onChange: any
    disableEdit: boolean
}

const RangeInput = (props: RangeInputProps): ReactElement => {
    const { id, label, value, onChange, disableEdit } = props

    const handleSliderChange = useCallback(
        (event: Event, newValue: number | number[]) => {
            onChange(newValue as number)
        },
        [onChange],
    )

    const handleInputChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            onChange(
                event.target.value === ''
                    ? minGeoFenceRadius
                    : Number(event.target.value),
            )
        },
        [onChange],
    )

    const handleBlur = useCallback(() => {
        if (value < minGeoFenceRadius) {
            onChange(minGeoFenceRadius)
        } else if (value > maxGeoFenceRadius) {
            onChange(maxGeoFenceRadius)
        }
    }, [value, onChange])

    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <InputLabel sx={{ opacity: '0.7', fontSize: '14px' }}>
                    {label}
                </InputLabel>
                <Box sx={{ width: '85px' }}>
                    <OutlinedInput
                        id={id + 'input'}
                        value={value}
                        size="small"
                        type="number"
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        disabled={disableEdit}
                        sx={{
                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                                {
                                    display: 'none',
                                },
                            '& input[type=number]': {
                                MozAppearance: 'textfield',
                            },
                        }}
                        inputProps={{
                            step: 10,
                            min: minGeoFenceRadius,
                            max: maxGeoFenceRadius,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                            style: {
                                fontSize: 14,
                                padding: '10px 0px 10px 10px',
                                minWidth: '35px',
                            },
                        }}
                        endAdornment={
                            <InputAdornment
                                position="end"
                                sx={{
                                    fontSize: '14px',
                                    opacity: disableEdit ? '0.5' : '1',
                                }}
                            >
                                m
                            </InputAdornment>
                        }
                    />
                </Box>
            </Box>
            <Box
                sx={{ flexDirection: 'column' }}
                display="flex"
                alignItems="left"
            >
                <Slider
                    id={id}
                    value={
                        typeof value === 'number' ? value : minGeoFenceRadius
                    }
                    onChange={handleSliderChange}
                    aria-labelledby="input-slider"
                    min={minGeoFenceRadius}
                    max={maxGeoFenceRadius}
                    disabled={disableEdit}
                    sx={{
                        marginRight: '20px',
                    }}
                />
            </Box>
        </Box>
    )
}

export default RangeInput
